import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  Box,
  Button,
  Divider,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { white } from '@styles/colors';
import { medium } from '@styles/fontWeights';
import { FC } from 'react';

type UserDetailColorRowProps = {
  label: string;
  value?: string | null;
  tooltip?: string;
  action: () => void;
};

const UserDetailColorRow: FC<UserDetailColorRowProps> = ({
  label,
  value,
  tooltip,
  action,
}) => {
  return (
    <>
      <Grid
        container
        alignItems="center"
        bgcolor={white}
        borderRadius={8}
        py={2}
      >
        <Grid item xs={12} sm={4}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography
              fontWeight={medium}
              display="flex"
              gap={1}
              alignItems="center"
            >
              {label}:{' '}
              {tooltip && (
                <Tooltip title={tooltip} placement="top" arrow>
                  <HelpOutlineIcon
                    sx={{
                      fontSize: '18px',
                      color: 'grey.400',
                      transition: 'color 0.35s ease',
                      '&:hover': { color: 'grey.900' },
                    }}
                  />
                </Tooltip>
              )}
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={4} justifyContent="center" display="flex">
          {value ? (
            <Box
              sx={{
                width: '65px',
                height: '65px',
                borderRadius: 5,
                bgcolor: value || '',
                boxShadow: '0 2px 8px 1px rgba(0,0,0,0.1)',
                border: '1px solid rgba(0,0,0,0.09)',
              }}
            />
          ) : (
            <Typography fontWeight={medium}>No Color</Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={4} justifyContent="end" display="flex">
          <Button
            color={value ? 'primary' : 'success'}
            id={`edit-button-${label.toLowerCase().replace(/\s+/g, '-')}`}
            variant="contained"
            sx={{
              padding: '4px 15px',
              fontSize: '14px',
            }}
            startIcon={
              value ? (
                <EditOutlinedIcon sx={{ fontSize: '16px' }} />
              ) : (
                <AddOutlinedIcon sx={{ fontSize: '16px' }} />
              )
            }
            onClick={action}
          >
            {value ? 'Edit' : 'Add'}
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: '7px' }} />
    </>
  );
};

export default UserDetailColorRow;
